import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Parameters = () => {
    document.title = "Parametrlər";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Parametrlər</h2>
                <div className="row g-4">
                    <div className="col-6">
                        <Link to={"product"}>Məhsul</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"service"}>Xidmət</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"group"}>Qrup</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"complect"}>Dəst</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"party"}>Partiya</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"series"}>Seriya</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"edit"}>Redaktə et</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"search"}>Sürətli axtarış</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"units"}>Ölçü vahidləri</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"kit"}>Bağlama</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"modification"}>Modifikasiya</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"pricetypes"}>Qiymət tipləri</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"archive"}>Arxivləmə</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
